module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_about02-d3bbcad3e700419d8a2f799fe833023d.png";